import { render, staticRenderFns } from "./AddValorFijo.vue?vue&type=template&id=56bb460e&"
import script from "./AddValorFijo.vue?vue&type=script&lang=js&"
export * from "./AddValorFijo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports